import React from 'react';
import { FaDiscord, FaSteam } from 'react-icons/fa';
import { SiBoosty } from 'react-icons/si';

const Footer: React.FC = () => {
    return (
        <footer className="h-[60px] flex justify-between items-center p-4 bg-gradient-to-r from-slate-800 to-gray-800 text-white w-full drop-shadow-md">
            <div className="text-md text-slate-400 font-semibold">
                © {(new Date().getFullYear())} Moroz Mods
            </div>

            <div className="flex space-x-4">
                <a
                    href="https://discord.gg/NCXhd9wZat"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-400 hover:text-[#5865F2] transition-colors duration-300"
                >
                    <FaDiscord size={24} />
                </a>

                <a
                    href="https://boosty.to/morozmods"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-400 hover:text-[#F15F2C] transition-colors duration-300"
                >
                    <SiBoosty size={24} />
                </a>

                <a
                    href="https://steamcommunity.com/profiles/76561199797231035/myworkshopfiles/?appid=221100"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-400 hover:text-white transition-colors duration-300"
                >
                    <FaSteam size={24} />
                </a>
            </div>
        </footer>
    );
};

export default Footer;